import {
  FaCheckCircle,
  FaDatabase,
  FaRocket,
  FaSync,
  FaUsers,
  FaClipboardList,
} from "react-icons/fa";

const benefits = [
  {
    icon: FaRocket,
    title: "Automated Email Discovery",
    description: "Find & verify emails automatically.",
  },
  {
    icon: FaSync,
    title: "Connect with 7,000+ Apps",
    description: "Sync with CRMs, Google Sheets, & more.",
  },
  {
    icon: FaClipboardList,
    title: "No-Code Setup",
    description: "Easy automation without coding skills.",
  },
  {
    icon: FaDatabase,
    title: "Google Sheets Integration",
    description: "Save emails automatically to Sheets.",
  },
  {
    icon: FaUsers,
    title: "CRM & Outreach Sync",
    description: "Send emails to HubSpot, Mailchimp, etc.",
  },
  {
    icon: FaCheckCircle,
    title: "Time-Saving & Efficient",
    description: "Reduce manual work & automate tasks.",
  },
];

export default function ZapierIntegration() {
  return (
    <div className="p-6 md:p-12 bg-gradient-to-b from-gray-50 to-blue-100 text-gray-900 transition-all duration-500 ease-in-out">
      {/* Benefits Section */}
      <section className="mb-16">
        <h2 className="text-3xl py-6 sm:text-4xl lg:text-[3rem] lg:leading-[3.5rem] font-bold text-center md:py-16">
          Why Integrate with Zapier?
        </h2>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-10">
          {benefits.map((benefit, index) => (
            <div
              key={index}
              className="relative bg-white p-8 rounded-2xl shadow-xl hover:shadow-2xl transition-all duration-500 ease-in-out flex flex-col items-center text-center border border-gray-200 transform hover:-translate-y-2 hover:scale-105"
            >
              <div className="absolute -top-6 flex items-center justify-center bg-[#4f7fff] text-white p-4 rounded-full shadow-md transition-transform duration-500 ease-in-out">
                <benefit.icon className="text-3xl" />
              </div>
              <h3 className="font-semibold text-xl text-gray-800 mt-8 transition-colors duration-300">
                {benefit.title}
              </h3>
              <p className="text-gray-600 mt-3 text-base leading-relaxed transition-opacity duration-300">
                {benefit.description}
              </p>
            </div>
          ))}
        </div>
      </section>
    </div>
  );
}
